// @flow
/* eslint react/no-array-index-key: 0 */
import * as React from "react"
import { IntlProvider } from "react-intl"
import styled from "styled-components"

import { Flex, Absolute, Relative, ButtonTransparent } from "rebass"
import us from "./us.jpeg"
import vn from "./vn.png"

const flags = [{ src: us, id: 1, name: "en" }, { src: vn, id: 2, name: "vi" }]

const Flag = styled.img.attrs({
  alt: `${props => props.alt}`
})`
  width: 50px;
  height: 30px;
`

const CustomButton = ButtonTransparent.extend`
  cursor: pointer;
`

export default class LanguageProvider extends React.Component<{
  messages: any,
  children: React.ReactNode
}> {
  state = {
    locale: "en"
  }

  handleFlagClicked = flagName => {
    this.setState({
      locale: flagName
    })
  }
  render() {
    return (
      <IntlProvider
        locale={this.state.locale}
        key={this.state.locale}
        messages={this.props.messages[this.state.locale]}
      >
        <div style={{ overflowX: "hidden" }}>
          <Relative>
            <Absolute top={0}>
              <Flex w="100vw" justifyContent="space-evenly">
                {flags.map(({ src, id, name }) => (
                  <Flex key={id} flexDirection="column" alignItems="center">
                    <CustomButton onClick={() => this.handleFlagClicked(name)}>
                      <Flag alt={name} src={src} />
                    </CustomButton>
                    {name.toUpperCase()}
                  </Flex>
                ))}
              </Flex>
            </Absolute>
          </Relative>
          {this.props.children}
        </div>
      </IntlProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/LanguageProvider.js